export type TemperatureUnit = 'C' | 'F';

export function resolveTripTemperatureUnit(trip: { temperatureUnit?: string | null }): TemperatureUnit {
  const unit = trip.temperatureUnit?.toUpperCase();
  if (unit === 'C' || unit === 'F') {
    return unit;
  }
  return resolveLocaleTemperatureUnit();
}

export function resolveLocaleTemperatureUnit(): TemperatureUnit {
  if (typeof navigator === 'undefined') {
    return 'F';
  }

  const locale = navigator.language ?? 'en-US';

  try {
    const intlLocale = new Intl.Locale(locale);
    const measurementSystem = (intlLocale as Intl.Locale & { measurementSystem?: string })
      .measurementSystem;
    if (measurementSystem === 'metric') {
      return 'C';
    }
    if (measurementSystem === 'us') {
      return 'F';
    }
  } catch {
    // ignore invalid locale
  }

  if (locale.startsWith('en-US')) {
    return 'F';
  }

  return locale.startsWith('en') ? 'F' : 'C';
}

export function celsiusToFahrenheit(celsius: number): number {
  return (celsius * 9) / 5 + 32;
}

export function fahrenheitToCelsius(fahrenheit: number): number {
  return ((fahrenheit - 32) * 5) / 9;
}

export function formatTemp(celsius: number, unit: TemperatureUnit): string {
  const value = unit === 'F' ? celsiusToFahrenheit(celsius) : celsius;
  return `${Math.round(value)}°`;
}

export function formatTempRange(highC: number, lowC: number, unit: TemperatureUnit): string {
  return `${formatTemp(highC, unit)} / ${formatTemp(lowC, unit)}`;
}
